import Vue from 'vue'

Vue.directive('pin', function (el, binding) {
  el.style.position = 'fixed'
  el.style.top = binding.value + 'px'
})
